{
  "familyId": "GELD-TERUG",
  "questions": [
    {
      "id": "GELD-TERUG-001",
      "familyId": "GELD-TERUG",
      "module": "Geld",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "geld_basis",
      "subSkill": "geld_teruggeven",
      "questionType": "money",
      "question": "Een winkelier vraagt je om precies €3,50 te maken met munten.",
      "_validationSource": "assembler",
      "options": ["€3,50", "€3,00", "€4,00", "€3,40"],
      "correctAnswer": 0,
      "data": { "money": { "mode": "make_amount", "currency": "EUR", "targetCents": 350, "allowedDenoms": [{ "valueCents": 200, "type": "coin", "label": "€2" }, { "valueCents": 100, "type": "coin", "label": "€1" }, { "valueCents": 50, "type": "coin", "label": "50 cent" }, { "valueCents": 20, "type": "coin", "label": "20 cent" }, { "valueCents": 10, "type": "coin", "label": "10 cent" }, { "valueCents": 5, "type": "coin", "label": "5 cent" }], "constraints": { "maxTokens": 8 } } },
      "conceptId": "make_amount_basic",
      "variantIndex": 1,
      "citoDifficulty": 0.18,
      "citoDiscrimination": 0.75,
      "pedagogy": { "dok": 1, "misconceptionTags": [] },
      "stimulusAids": [{ "type": "money", "data": { "amount": 350, "showCoins": true, "label": "Doel: €3,50" } }],
      "supportAids": [{ "type": "rule", "showWhen": "wrong", "data": { "title": "Hoe maak je €3,50?", "content": "Begin met de grootste munt die past: €2. Dan nog €1,50 over. Gebruik €1 + 50 cent. Totaal: €2 + €1 + 50c = €3,50.", "icon": "lightbulb" } }],
      "feedback": {
        "explanationText": "De winkelier helpt je: begin met de grootste munt die past en werk naar beneden. Pak €2 (grootste munt ≤ €3,50), dan €1 (samen €3), dan 50 cent. Totaal: €2 + €1 + 50 cent = €3,50.",
        "solutionSteps": ["Pak de grootste munt die past: €2", "Nog €1,50 over → pak €1", "Nog €0,50 over → pak 50 cent", "Totaal: €2 + €1 + 50 cent = €3,50"],
        "distractorExplanations": {
          "0": "Goed! €2 + €1 + 50 cent = €3,50.",
          "1": "Je dacht waarschijnlijk dat je klaar was bij €3,00. Maar €3,00 is 50 cent te weinig — je mist nog een 50-cent munt. Onthoud: tel altijd na of je totaal klopt.",
          "2": "Je dacht waarschijnlijk dat je een extra munt nodig had. Maar €4,00 is 50 cent te veel. Onthoud: het moet precies kloppen, niet meer.",
          "3": "Je dacht waarschijnlijk dat 40 cent genoeg was. Maar €3,40 is 10 cent te weinig — je hebt 50 cent nodig, niet 40 cent. Onthoud: controleer het verschil."
        }
      }
    },
    {
      "id": "GELD-TERUG-002",
      "familyId": "GELD-TERUG",
      "module": "Geld",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "geld_basis",
      "subSkill": "geld_teruggeven",
      "questionType": "money",
      "question": "Een bakker vraagt je om precies €5,75 te maken met munten en biljetten.",
      "_validationSource": "assembler",
      "options": ["€5,75", "€5,50", "€6,00", "€5,70"],
      "correctAnswer": 0,
      "data": { "money": { "mode": "make_amount", "currency": "EUR", "targetCents": 575, "allowedDenoms": [{ "valueCents": 500, "type": "bill", "label": "€5" }, { "valueCents": 200, "type": "coin", "label": "€2" }, { "valueCents": 100, "type": "coin", "label": "€1" }, { "valueCents": 50, "type": "coin", "label": "50 cent" }, { "valueCents": 20, "type": "coin", "label": "20 cent" }, { "valueCents": 10, "type": "coin", "label": "10 cent" }, { "valueCents": 5, "type": "coin", "label": "5 cent" }], "constraints": { "maxTokens": 10 } } },
      "conceptId": "make_amount_bills_coins",
      "variantIndex": 2,
      "citoDifficulty": 0.22,
      "citoDiscrimination": 0.73,
      "pedagogy": { "dok": 1, "misconceptionTags": [] },
      "stimulusAids": [{ "type": "money", "data": { "amount": 575, "showCoins": true, "showBills": true, "label": "Doel: €5,75" } }],
      "supportAids": [{ "type": "rule", "showWhen": "wrong", "data": { "title": "Hoe maak je €5,75?", "content": "Gebruik het €5-biljet voor het grote deel. Dan nog €0,75 over: 50 cent + 20 cent + 5 cent = 75 cent.", "icon": "lightbulb" } }],
      "feedback": {
        "explanationText": "De bakker helpt je: gebruik het biljet voor het grote deel, dan munten voor de rest. Pak het €5-biljet, dan 50 cent + 20 cent + 5 cent = 75 cent. Totaal: €5 + 50c + 20c + 5c = €5,75.",
        "solutionSteps": ["Pak het €5-biljet", "Nog €0,75 over", "50 cent + 20 cent + 5 cent = 75 cent", "Totaal: €5,75"],
        "distractorExplanations": {
          "0": "Goed! €5 + 50 cent + 20 cent + 5 cent = €5,75.",
          "1": "Je dacht waarschijnlijk dat 50 cent genoeg was voor de rest. Maar €5,50 is 25 cent te weinig — je mist nog 20 cent + 5 cent. Onthoud: tel alle centen na.",
          "2": "Je dacht waarschijnlijk dat je naar boven moest afronden. Maar €6,00 is 25 cent te veel — het moet precies kloppen. Onthoud: geen afronden bij geld maken.",
          "3": "Je dacht waarschijnlijk dat je de 5 cent kon overslaan. Maar €5,70 is 5 cent te weinig. Onthoud: ook de kleinste munten tellen mee."
        }
      }
    },
    {
      "id": "GELD-TERUG-003",
      "familyId": "GELD-TERUG",
      "module": "Geld",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "geld_basis",
      "subSkill": "geld_teruggeven",
      "questionType": "money",
      "question": "Een snackbarhouder verkoopt een snoepje voor €0,85. Je betaalt met €1,00. Hoeveel wisselgeld krijg je?",
      "_validationSource": "assembler",
      "options": ["€0,15", "€0,85", "€0,25", "€0,10"],
      "correctAnswer": 0,
      "data": { "money": { "mode": "give_change", "currency": "EUR", "priceCents": 85, "paidCents": 100, "targetCents": 15, "allowedDenoms": [{ "valueCents": 50, "type": "coin", "label": "50 cent" }, { "valueCents": 20, "type": "coin", "label": "20 cent" }, { "valueCents": 10, "type": "coin", "label": "10 cent" }, { "valueCents": 5, "type": "coin", "label": "5 cent" }, { "valueCents": 2, "type": "coin", "label": "2 cent" }, { "valueCents": 1, "type": "coin", "label": "1 cent" }], "constraints": { "maxTokens": 5 } } },
      "conceptId": "give_change_simple",
      "variantIndex": 3,
      "citoDifficulty": 0.25,
      "citoDiscrimination": 0.74,
      "pedagogy": { "dok": 1, "misconceptionTags": [] },
      "stimulusAids": [{ "type": "money", "data": { "amount": 100, "showCoins": true, "label": "Je betaalt €1,00" } }],
      "supportAids": [{ "type": "rule", "showWhen": "wrong", "data": { "title": "Wisselgeld berekenen", "content": "Wisselgeld = betaald − prijs. Hier: €1,00 − €0,85 = €0,15. Dat is 10 cent + 5 cent.", "icon": "lightbulb" } }],
      "feedback": {
        "explanationText": "De snackbarhouder berekent: wisselgeld = betaald − prijs. Je betaalt €1,00 en het snoepje kost €0,85. Wisselgeld = €1,00 − €0,85 = €0,15. Dat is 10 cent + 5 cent.",
        "solutionSteps": ["Betaald: €1,00", "Prijs: €0,85", "Wisselgeld = €1,00 − €0,85 = €0,15", "Teruggeven: 10 cent + 5 cent"],
        "distractorExplanations": {
          "0": "Goed! Wisselgeld = €1,00 − €0,85 = €0,15.",
          "1": "Je dacht waarschijnlijk dat de prijs het wisselgeld is. Maar €0,85 is wat het snoepje kost, niet wat je terugkrijgt. Onthoud: wisselgeld = betaald − prijs.",
          "2": "Je dacht waarschijnlijk dat het verschil €0,25 is. Maar €1,00 − €0,85 = €0,15, niet €0,25. Onthoud: reken het aftrekken stap voor stap na.",
          "3": "Je dacht waarschijnlijk dat je alleen 10 cent terugkrijgt. Maar €1,00 − €0,85 = €0,15, niet €0,10. Je mist nog 5 cent. Onthoud: tel alle centen."
        }
      }
    },
    {
      "id": "GELD-TERUG-004",
      "familyId": "GELD-TERUG",
      "module": "Geld",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "geld_basis",
      "subSkill": "geld_teruggeven",
      "questionType": "money",
      "question": "Een marktkoopman vraagt je om precies €2,35 te maken met zo min mogelijk munten.",
      "_validationSource": "assembler",
      "options": ["€2,35", "€2,30", "€2,40", "€2,45"],
      "correctAnswer": 0,
      "data": { "money": { "mode": "make_amount", "currency": "EUR", "targetCents": 235, "allowedDenoms": [{ "valueCents": 200, "type": "coin", "label": "€2" }, { "valueCents": 100, "type": "coin", "label": "€1" }, { "valueCents": 50, "type": "coin", "label": "50 cent" }, { "valueCents": 20, "type": "coin", "label": "20 cent" }, { "valueCents": 10, "type": "coin", "label": "10 cent" }, { "valueCents": 5, "type": "coin", "label": "5 cent" }], "constraints": { "preferMinimalTokens": true, "maxTokens": 6 } } },
      "conceptId": "make_amount_minimal",
      "variantIndex": 4,
      "citoDifficulty": 0.30,
      "citoDiscrimination": 0.72,
      "pedagogy": { "dok": 1, "misconceptionTags": [] },
      "stimulusAids": [{ "type": "money", "data": { "amount": 235, "showCoins": true, "label": "Doel: €2,35" } }],
      "supportAids": [{ "type": "rule", "showWhen": "wrong", "data": { "title": "Zo min mogelijk munten", "content": "Gebruik altijd de grootste munt die past. €2 + 20c + 10c + 5c = €2,35 (4 munten).", "icon": "lightbulb" } }],
      "feedback": {
        "explanationText": "De marktkoopman helpt je: gebruik zo min mogelijk munten door altijd de grootste munt te pakken die past. Pak €2, dan 20 cent, dan 10 cent, dan 5 cent. Totaal: €2 + 20c + 10c + 5c = €2,35 (4 munten).",
        "solutionSteps": ["Grootste munt ≤ €2,35: pak €2", "Nog 35 cent over → pak 20 cent", "Nog 15 cent over → pak 10 cent", "Nog 5 cent over → pak 5 cent", "Totaal: €2,35 in 4 munten"],
        "distractorExplanations": {
          "0": "Goed! €2 + 20 cent + 10 cent + 5 cent = €2,35 (4 munten — minimaal).",
          "1": "Je dacht waarschijnlijk dat je klaar was bij €2,30. Maar €2,30 is 5 cent te weinig — je mist nog een 5-cent munt. Onthoud: tel altijd na.",
          "2": "Je dacht waarschijnlijk dat je een extra munt nodig had. Maar €2,40 is 5 cent te veel. Onthoud: het moet precies kloppen.",
          "3": "Je dacht waarschijnlijk dat je 45 cent aan munten nodig had. Maar 20 + 10 + 5 = 35 cent, niet 45 cent. Onthoud: tel de centen stap voor stap op."
        }
      }
    },
    {
      "id": "GELD-TERUG-005",
      "familyId": "GELD-TERUG",
      "module": "Geld",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "geld_basis",
      "subSkill": "geld_teruggeven",
      "questionType": "money",
      "question": "Een bakker verkoopt een broodje voor €2,50. Je betaalt met €5,00. Hoeveel wisselgeld krijg je?",
      "_validationSource": "assembler",
      "options": ["€2,50", "€2,00", "€3,00", "€2,40"],
      "correctAnswer": 0,
      "data": { "money": { "mode": "give_change", "currency": "EUR", "priceCents": 250, "paidCents": 500, "targetCents": 250, "allowedDenoms": [{ "valueCents": 200, "type": "coin", "label": "€2" }, { "valueCents": 100, "type": "coin", "label": "€1" }, { "valueCents": 50, "type": "coin", "label": "50 cent" }, { "valueCents": 20, "type": "coin", "label": "20 cent" }, { "valueCents": 10, "type": "coin", "label": "10 cent" }], "constraints": { "maxTokens": 5 } } },
      "conceptId": "give_change_round",
      "variantIndex": 5,
      "citoDifficulty": 0.20,
      "citoDiscrimination": 0.73,
      "pedagogy": { "dok": 1, "misconceptionTags": [] },
      "stimulusAids": [{ "type": "money", "data": { "amount": 500, "showBills": true, "label": "Je betaalt €5,00" } }],
      "supportAids": [{ "type": "rule", "showWhen": "wrong", "data": { "title": "Wisselgeld bij de bakker", "content": "Wisselgeld = betaald − prijs = €5,00 − €2,50 = €2,50. Geef terug: €2 + 50 cent.", "icon": "lightbulb" } }],
      "feedback": {
        "explanationText": "De bakker berekent: wisselgeld = betaald − prijs. Je betaalt €5,00 en het broodje kost €2,50. Wisselgeld = €5,00 − €2,50 = €2,50. Geef terug: €2 + 50 cent.",
        "solutionSteps": ["Betaald: €5,00", "Prijs: €2,50", "Wisselgeld = €5,00 − €2,50 = €2,50", "Teruggeven: €2 + 50 cent"],
        "distractorExplanations": {
          "0": "Goed! Wisselgeld = €5,00 − €2,50 = €2,50.",
          "1": "Je dacht waarschijnlijk dat je alleen de euro's aftrekt. Maar €5,00 − €2,50 = €2,50, niet €2,00. Je vergeet de 50 cent. Onthoud: trek ook de centen af.",
          "2": "Je dacht waarschijnlijk dat €5 − €2 = €3. Maar je moet ook de 50 cent aftrekken: €5,00 − €2,50 = €2,50. Onthoud: reken met het hele bedrag.",
          "3": "Je dacht waarschijnlijk dat het verschil €2,40 is. Maar €5,00 − €2,50 = €2,50, niet €2,40. Onthoud: reken het aftrekken stap voor stap na."
        }
      }
    },
    {
      "id": "GELD-TERUG-006",
      "familyId": "GELD-TERUG",
      "module": "Geld",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "geld_basis",
      "subSkill": "geld_teruggeven",
      "questionType": "money",
      "question": "Een ijsverkoper vraagt je om precies €4,20 te maken met munten.",
      "_validationSource": "assembler",
      "options": ["€4,20", "€4,00", "€4,30", "€4,10"],
      "correctAnswer": 0,
      "data": { "money": { "mode": "make_amount", "currency": "EUR", "targetCents": 420, "allowedDenoms": [{ "valueCents": 200, "type": "coin", "label": "€2" }, { "valueCents": 100, "type": "coin", "label": "€1" }, { "valueCents": 50, "type": "coin", "label": "50 cent" }, { "valueCents": 20, "type": "coin", "label": "20 cent" }, { "valueCents": 10, "type": "coin", "label": "10 cent" }], "constraints": { "maxTokens": 8 } } },
      "conceptId": "make_amount_twenties",
      "variantIndex": 6,
      "citoDifficulty": 0.28,
      "citoDiscrimination": 0.74,
      "pedagogy": { "dok": 1, "misconceptionTags": [] },
      "stimulusAids": [{ "type": "money", "data": { "amount": 420, "showCoins": true, "label": "Doel: €4,20" } }],
      "supportAids": [{ "type": "rule", "showWhen": "wrong", "data": { "title": "Hoe maak je €4,20?", "content": "€2 + €2 + 20 cent = €4,20. Begin met de grootste munten.", "icon": "lightbulb" } }],
      "feedback": {
        "explanationText": "De ijsverkoper helpt je: begin met de grootste munt die past. Pak 2×€2 (samen €4), dan 20 cent. Totaal: €2 + €2 + 20 cent = €4,20.",
        "solutionSteps": ["Pak 2×€2 = €4", "Nog 20 cent over → pak 20 cent", "Totaal: €4,20"],
        "distractorExplanations": {
          "0": "Goed! €2 + €2 + 20 cent = €4,20.",
          "1": "Je dacht waarschijnlijk dat je klaar was bij €4,00. Maar €4,00 is 20 cent te weinig — je mist nog een 20-cent munt. Onthoud: tel altijd na.",
          "2": "Je dacht waarschijnlijk dat je 30 cent nodig had. Maar €4,30 is 10 cent te veel — je pakte waarschijnlijk een extra 10-cent munt. Onthoud: het moet precies kloppen.",
          "3": "Je dacht waarschijnlijk dat 10 cent genoeg was. Maar €4,10 is 10 cent te weinig — je hebt 20 cent nodig, niet 10 cent. Onthoud: pak de juiste munt."
        }
      }
    }
  ]
}